const REUSED_MAPS = {
  ACURA_MDX_2022: [
    {
      label: 'Performance',
      imageUrlPortrait: '/img/short-videos/2022-acura-mdx/portrait/performance_desktop.jpg',
      videoIdPortrait: 'i0PI3vkvDtE',
      videoDuration: '1:58',
    },
    {
      label: 'Storage',
      imageUrlPortrait: '/img/short-videos/2022-acura-mdx/portrait/storage_desktop.jpg',
      videoIdPortrait: '0ik6puZcJEA',
      videoDuration: '0:50',
    },
    {
      label: 'Fuel Economy',
      imageUrlPortrait: '/img/short-videos/2022-acura-mdx/portrait/fuel-economy_desktop.jpg',
      videoIdPortrait: 'kC_-q7s9tt4',
      videoDuration: '0:48',
    },
  ],
  CADILLAC_ESCALADE_2023: [
    {
      label: 'Performance',
      title: 'The Cadillac Escalade V Has a V Mode: Here’s What You Need to Know',
      videoIdPortrait: 'tHWw9jYV1iE',
      videoDuration: '0:38',
    },
    {
      label: 'Exterior',
      title: 'Here’s How to Tell the Cadillac Escalade V Apart From Lesser Models',
      videoIdPortrait: 'DBhBc9XBANM',
      videoDuration: '0:48',
    },
    {
      label: 'Technology',
      title: 'Everything You Need to Know About the Cadillac Escalade V’s High-Tech Interior',
      videoIdPortrait: 'oQsktTTnFJE',
      videoDuration: '0:50',
    },
  ],
  CHEVROLET_CAMARO_2023: [
    {
      label: 'Interior',
      title: 'Chevy Camaro Convertible 60-Second Interior Overview',
      videoIdPortrait: 'vPrnsGIuqBg',
      videoDuration: '0:39',
    },
    {
      label: 'Technology',
      title: 'Quick Tutorial on Operating the Chevy Camaro Convertible’s Soft Top',
      videoIdPortrait: 'biOuwV7jLMg',
      videoDuration: '0:47',
    },
    {
      label: 'Wildcard',
      title: 'Everything You Need to Know About the Chevy Camaro Model Lineup',
      videoIdPortrait: 'ASOKvRZnJug',
      videoDuration: '1:04',
    },
  ],
  CHEVROLET_CORVETTE_2020: [
    {
      label: 'Performance',
      title: 'Chevrolet Corvette Stingray: Performance Stats',
      videoIdPortrait: '_bGZO_33-vw',
      videoDuration: '0:48',
    },
    {
      label: 'Exterior',
      title: 'Chevrolet Corvette Stingray: Exterior Walkaround',
      videoIdPortrait: 'pacL3KbwfGU',
      videoDuration: '0:57',
    },
    {
      label: 'Interior',
      title: 'Chevrolet Corvette Stingray: Interior Overview',
      videoIdPortrait: 'YLmhOYzpkLU',
      videoDuration: '0:58',
    },
  ],
  CHEVROLET_SILVERADO_1500_2023: [
    {
      label: 'Performance',
      title: '2023 Chevrolet Silverado 1500 Powertrain Choices',
      videoIdPortrait: 'EmcJ5mv4oP0',
      videoDuration: '0:38',
    },
    {
      label: 'Technology',
      title: '2023 Chevrolet Silverado 1500 Tech Overview',
      videoIdPortrait: 'OOPTLSCcOOQ',
      videoDuration: '0:37',
    },
    {
      label: 'Storage',
      title: '2023 Chevrolet Silverado 1500: All About the Bed',
      videoIdPortrait: 'wzQ81bYP9Q4',
      videoDuration: '0:28',
    },
  ],
  CHEVROLET_TAHOE_2022: [
    {
      label: 'Performance',
      title: 'Chevrolet Tahoe: Engines, Towing and Fuel Economy',
      videoIdPortrait: 'KLoGK7wftLc',
      videoDuration: '0:33',
    },
    {
      label: 'Exterior',
      title: 'Chevrolet Tahoe: Z71 Package Review',
      videoIdPortrait: 'Qs2W2KztOMw',
      videoDuration: '0:36',
    },
    {
      label: 'Interior',
      title: 'Chevrolet Tahoe: Interior Overview',
      videoIdPortrait: 'MKGVVxWR4_c',
      videoDuration: '0:43',
    },
  ],
  FORD_BRONCO_2023: [
    {
      label: 'Performance',
      title: 'Ford Bronco Off-Road Capability: Everything You Need to Know',
      videoIdPortrait: 'bvr3o3nGbOw',
      videoDuration: '0:41',
      imageUrlPortrait: '/img/short-videos/2023-ford-bronco/portrait/performance.jpg',
    },
    {
      label: 'Interior',
      title: 'Ford Bronco Interior Buttons & Switches: Everything You Need to Know',
      videoIdPortrait: '72t0UegUiC4',
      videoDuration: '0:50',
      imageUrlPortrait: '/img/short-videos/2023-ford-bronco/portrait/interior.jpg',
    },
    {
      label: 'Storage',
      title: 'Know This Before Taking Your Ford Bronco Off-Road',
      videoIdPortrait: 'AUcn9kyuDKM',
      videoDuration: '0:45',
      imageUrlPortrait: '/img/short-videos/2023-ford-bronco/portrait/storage.jpg',
    },
  ],
  FORD_ESCAPE_2023: [
    {
      label: 'Exterior',
      title: '2023 Ford Escape Exterior Overview: Everything About the Refreshed Look',
      videoIdPortrait: 'CQqQ_W8z6K8',
      videoDuration: '0:28',
    },
    {
      label: 'Interior',
      title: 'Ford Escape Interior and Cargo Space Overview',
      videoIdPortrait: 'NltIYcupemI',
      videoDuration: '0:56',
    },
    {
      label: 'Technology',
      title: 'Ford Escape Tech Overview: Big Screens and Lots of Features',
      videoIdPortrait: 'Yqtx61E43U8',
      videoDuration: '0:37',
    },
  ],
  FORD_F150_2023: [
    {
      label: 'Interior',
      title: 'Ford <span class="text-nowrap">F-150:</span> Innovative Interior Features Explained',
      videoIdPortrait: 'YV05BkJNt6c',
      videoDuration: '0:51',
      imageUrlPortrait: '/img/short-videos/2023-ford-f150/portrait/interior.jpg',
    },
    {
      label: 'Technology',
      title: `Ford <span class="text-nowrap">F-150's</span> Pro Power Onboard Explained`,
      videoIdPortrait: 'mv3m2g-96jA',
      videoDuration: '0:30',
      imageUrlPortrait: '/img/short-videos/2023-ford-f150/portrait/technology.jpg',
    },
    {
      label: 'Storage',
      title: 'Ford <span class="text-nowrap">F-150</span> Bed And Tailgate: Everything You Need to Know',
      videoIdPortrait: 'Auu63i4vFb8',
      videoDuration: '0:45',
      imageUrlPortrait: '/img/short-videos/2023-ford-f150/portrait/storage.jpg',
    },
  ],
  FORD_F150_LIGHTNING_2023: [
    {
      label: 'Performance',
      title: 'Can the Ford <span class="text-nowrap">F-150</span> Lightning Really Tow?',
      videoIdPortrait: 'DQYTfO2i1fg',
      videoDuration: '0:38',
    },
    {
      label: 'Interior',
      title: 'Ford <span class="text-nowrap">F-150</span> Lightning Interior Overview: No Compromise',
      videoIdPortrait: 'tkLd504wirw',
      videoDuration: '0:51',
    },
    {
      label: 'Wildcard',
      title: `Here’s Why the Ford <span class="text-nowrap">F-150</span> Lightning Is Still a True Ford Truck`,
      videoIdPortrait: 'YGFhqkF_Jng',
      videoDuration: '0:43',
    },
  ],
  FORD_MAVERICK_2023: [
    {
      label: 'Comfort',
      title: 'Ford Maverick Innovative Interior Storage Solutions Explained',
      videoIdPortrait: 'mLdKXPSkvdU',
      videoDuration: '0:48',
      imageUrlPortrait: '/img/short-videos/2023-ford-maverick/portrait/comfort.jpg',
    },
    {
      label: 'Interior',
      title: 'Ford Maverick: Everything You Need to Know About the Interior',
      videoIdPortrait: 'btW4N61atLk',
      videoDuration: '0:37',
      imageUrlPortrait: '/img/short-videos/2023-ford-maverick/portrait/interior.jpg',
    },
    {
      label: 'Storage',
      title: 'Ford Maverick Bed: Everything You Need to Know',
      videoIdPortrait: 'M56kAzf8sVw',
      videoDuration: '0:46',
      imageUrlPortrait: '/img/short-videos/2023-ford-maverick/portrait/storage.jpg',
    },
  ],
  FORD_MUSTANG_MACH_E_2021: [
    {
      label: 'Interior',
      title: 'Ford Mustang <span class="text-nowrap">Mach-E:</span> Interior & Tech Overview',
      videoIdPortrait: '5FAt82IflJw',
      videoDuration: '0:45',
    },
    {
      label: 'Storage',
      title: 'Ford Mustang <span class="text-nowrap">Mach-E:</span> Cargo Room & Interior Space',
      videoIdPortrait: 'RdcdJxMz4Xg',
      videoDuration: '0:49',
    },
    {
      label: 'Fuel Economy',
      title: 'Ford Mustang <span class="text-nowrap">Mach-E:</span> Range & Charging',
      videoIdPortrait: 'pttPRj9iXN4',
      videoDuration: '0:43',
    },
  ],
  HONDA_ACCORD_2023: [
    {
      label: 'Interior',
      title: '2023 Honda Accord Interior Space',
      videoIdPortrait: 'nZyvKS71WeQ',
      videoDuration: '0:32',
    },
    {
      label: 'Technology',
      title: '2023 Honda Accord Tech Overview',
      videoIdPortrait: 'IT3pc0keJCY',
      videoDuration: '0:36',
    },
    {
      label: 'Wildcard',
      title: '2023 Honda Accord Hybrid Trims',
      videoIdPortrait: 'u-hIDHQrOeo',
      videoDuration: '0:40',
    },
  ],
  HONDA_CIVIC_2023: [
    {
      label: 'Comfort',
      title: 'Honda Civic Seat Comfort: Everything You Need to Know',
      videoIdPortrait: 'IyVe0yjAyXg',
      videoDuration: '0:53',
      imageUrlPortrait: '/img/short-videos/2023-honda-civic/portrait/comfort.jpg',
    },
    {
      label: 'Interior',
      title: 'Why the Honda Civic Is the Most Refined Compact Sedan',
      videoIdPortrait: 'OxX7D9MQ6Jk',
      videoDuration: '0:45',
      imageUrlPortrait: '/img/short-videos/2023-honda-civic/portrait/interior.jpg',
    },
    {
      label: 'Storage',
      title: 'Here’s What You Need to Know About Carrying Your Kids in the Honda Civic',
      videoIdPortrait: 'o6lxqp0Dom8',
      videoDuration: '0:40',
      imageUrlPortrait: '/img/short-videos/2023-honda-civic/portrait/storage.jpg',
    },
  ],
  HONDA_HRV_2024: [
    {
      label: 'Comfort',
      title:
        'This Is How the Honda <span class="text-nowrap">HR-V</span> Compares to the <span class="text-nowrap">CR-V</span>',
      videoIdPortrait: 'LO9ArJov76Y',
      videoDuration: '0:23',
    },
    {
      label: 'Interior',
      title: 'Honda <span class="text-nowrap">HR-V</span> Standard Equipment Overview',
      videoIdPortrait: 'v5f_xLO8r1w',
      videoDuration: '0:31',
    },
    {
      label: 'Storage',
      title: 'Honda <span class="text-nowrap">HR-V</span> Cargo Overview',
      videoIdPortrait: 'ZonVaqtdeAs',
      videoDuration: '0:28',
    },
  ],
  JEEP_GRAND_CHEROKEE_2023: [
    {
      label: 'Technology',
      title: '2023 Jeep Grand Cherokee Tech Overview',
      videoIdPortrait: '7j75V3Uizt0',
      videoDuration: '0:41',
    },
    {
      label: 'Value',
      title: '2023 Jeep Grand Cherokee Model Lineup',
      videoIdPortrait: 'eC1TyJu7So0',
      videoDuration: '0:38',
    },
    {
      label: 'Wildcard',
      title: '2023 Jeep Grand Cherokee 4xe: What You Should Know About the Plug-in Hybrid',
      videoIdPortrait: '47r5IJ6D854',
      videoDuration: '0:36',
    },
  ],
  KIA_SORENTO_2021: [
    {
      label: 'Performance',
      imageUrlPortrait: '/img/short-videos/2021-kia-sorento/portrait/performance_desktop.jpg',
      videoIdPortrait: 'Stt1PeZR-PY',
      videoDuration: '0:25',
    },
    {
      label: 'Storage',
      imageUrlPortrait: '/img/short-videos/2021-kia-sorento/portrait/storage_desktop.jpg',
      videoIdPortrait: '2Sa8-Er0vxY',
      videoDuration: '0:43',
    },
    {
      label: 'Fuel Economy',
      imageUrlPortrait: '/img/short-videos/2021-kia-sorento/portrait/fuel-economy_desktop.jpg',
      videoIdPortrait: 'xJK1z39v_rI',
      videoDuration: '0:56',
    },
  ],
  KIA_SPORTAGE_2023: [
    {
      label: 'Performance',
      imageUrlPortrait: '/img/short-videos/2023-kia-sportage/portrait/performance_desktop.jpg',
      videoIdPortrait: 'ta7ZV7tXjXc',
      videoDuration: '1:38',
    },
    {
      label: 'Interior',
      imageUrlPortrait: '/img/short-videos/2023-kia-sportage/portrait/interior_desktop.jpg',
      videoIdPortrait: 'nDMbKWcaYzo',
      videoDuration: '1:29',
    },
    {
      label: 'Storage',
      imageUrlPortrait: '/img/short-videos/2023-kia-sportage/portrait/storage_desktop.jpg',
      videoIdPortrait: 'DTu_IbELOgc',
      videoDuration: '0:55',
    },
  ],
  KIA_TELLURIDE_2023: [
    {
      label: 'Comfort',
      title: 'Kia Telluride: Space and Comfort',
      videoIdPortrait: 'SsvYZ_Uglxk',
      videoDuration: '1:00',
    },
    {
      label: 'Exterior',
      title: 'Kia Telluride: X-Pro Package Review',
      videoIdPortrait: 'hqfuQDyQvJY',
      videoDuration: '0:36',
    },
    {
      label: 'Interior',
      title: 'Kia Telluride: Interior Review',
      videoIdPortrait: 'q8NiYLrZ0b8',
      videoDuration: '0:50',
    },
  ],
  MAZDA_CX5_2023: [
    {
      label: 'Performance',
      title: 'Mazda <span class="text-nowrap">CX-5:</span> Engines, Performance and Fuel Economy',
      videoIdPortrait: '9slbvVVDX44',
      videoDuration: '0:41',
    },
    {
      label: 'Interior',
      title: 'Mazda <span class="text-nowrap">CX-5:</span> Is It Practical?',
      videoIdPortrait: 'vuHkCJ9vF4I',
      videoDuration: '0:39',
    },
    {
      label: 'Technology',
      title: 'Mazda <span class="text-nowrap">CX-5:</span> Interior Tech Review',
      videoIdPortrait: 'AEHn2BBLVS0',
      videoDuration: '0:32',
    },
  ],
  MAZDA_CX50_2023: [
    {
      label: 'Performance',
      imageUrlPortrait: '/img/short-videos/2023-mazda-cx50/portrait/performance_desktop.jpg',
      videoIdPortrait: 'yH5BNrXLhGA',
      videoDuration: '0:49',
    },
    {
      label: 'Interior',
      imageUrlPortrait: '/img/short-videos/2023-mazda-cx50/portrait/interior_desktop.jpg',
      videoIdPortrait: 'rk2FtPdIsM4',
      videoDuration: '1:51',
    },
    {
      label: 'Storage',
      imageUrlPortrait: '/img/short-videos/2023-mazda-cx50/portrait/storage_desktop.jpg',
      videoIdPortrait: 'NZViv0Y9zqE',
      videoDuration: '1:19',
    },
  ],
  MERCEDES_BENZ_GLS_CLASS_2022: [
    {
      label: 'Performance',
      imageUrlPortrait: '/img/short-videos/2022-mercedes-benz-gls-class/portrait/performance_desktop.jpg',
      videoIdPortrait: 'qMpej7DX9aY',
      videoDuration: '1:20',
    },
    {
      label: 'Interior',
      imageUrlPortrait: '/img/short-videos/2022-mercedes-benz-gls-class/portrait/interior_desktop.jpg',
      videoIdPortrait: '13qOI0nGyJ8',
      videoDuration: '2:05',
    },
    {
      label: 'Storage',
      imageUrlPortrait: '/img/short-videos/2022-mercedes-benz-gls-class/portrait/storage_desktop.jpg',
      videoIdPortrait: '0WLcvDamA5Y',
      videoDuration: '0:31',
    },
  ],
  PORSCHE_911_2023: [
    {
      label: 'Interior',
      title: 'Interior Configurability in the Porsche 911 Carrera GTS',
      videoIdPortrait: 'ZostqEHCllo',
      videoDuration: '0:40',
    },
    {
      label: 'Storage',
      title: 'How You Can Store Your Stuff in the Porsche 911 Carrera GTS',
      videoIdPortrait: '909-L74MsgU',
      videoDuration: '0:52',
    },
    {
      label: 'Wildcard',
      title: 'Here’s Why the Porsche 911 Carrera GTS Is the Sweet Spot of the Model Lineup',
      videoIdPortrait: '8ZOPG9YvZzA',
      videoDuration: '0:59',
    },
  ],
  RIVIAN_R1T_2022: [
    {
      label: 'Interior',
      title: 'Rivian R1T: Interior Overview',
      videoIdPortrait: 'J6ZO33TDYBE',
      videoDuration: '0:52',
    },
    {
      label: 'Storage',
      title: 'Rivian R1T: Exterior Storage',
      videoIdPortrait: 'PYkEZbMdUSI',
      videoDuration: '0:59',
    },
    {
      label: 'Fuel Economy',
      title: 'Rivian R1T: Range & Charging',
      videoIdPortrait: 'j17HJjt7Hi4',
      videoDuration: '0:43',
    },
  ],
  TESLA_MODEL_Y_2023: [
    {
      label: 'Interior',
      title: 'Tesla Model Y: Interior Overview',
      videoIdPortrait: 'qNyEwI_zqBA',
      videoDuration: '0:59',
    },
    {
      label: 'Storage',
      title: 'How Spacious Is the Tesla Model Y?',
      videoIdPortrait: 'ktMB-Xt0rKI',
      videoDuration: '0:58',
    },
    {
      label: 'Fuel Economy',
      title: 'Tesla Model Y: Range & Charging',
      videoIdPortrait: '7B3-J2aYxEo',
      videoDuration: '0:47',
    },
  ],
  TOYOTA_CAMRY_HYBRID_2023: [
    {
      label: 'Interior',
      title: 'Toyota Camry Hybrid: Interior Review',
      videoIdPortrait: '973cAK-Cm1M',
      videoDuration: '1:00',
    },
    {
      label: 'Storage',
      title: 'Toyota Camry Hybrid: Passenger and Cargo Space',
      videoIdPortrait: 'sG_MI-ZG7tw',
      videoDuration: '0:54',
    },
    {
      label: 'Fuel Economy',
      title: 'Toyota Camry Hybrid: Fuel Economy',
      videoIdPortrait: 'Sg-8Ge1aYyI',
      videoDuration: '0:55',
    },
  ],
  TOYOTA_COROLLA_CROSS_2022: [
    {
      label: 'Performance',
      imageUrlPortrait: '/img/short-videos/2022-toyota-corolla-cross/portrait/performance_desktop.jpg',
      videoIdPortrait: 'zZ0d8uwP9es',
      videoDuration: '1:27',
    },
    {
      label: 'Interior',
      imageUrlPortrait: '/img/short-videos/2022-toyota-corolla-cross/portrait/interior_desktop.jpg',
      videoIdPortrait: '-O1VOy230eg',
      videoDuration: '1:00',
    },
    {
      label: 'Storage',
      imageUrlPortrait: '/img/short-videos/2022-toyota-corolla-cross/portrait/storage_desktop.jpg',
      videoIdPortrait: 'ZeKhpA1qhuE',
      videoDuration: '0:35',
    },
  ],
  TOYOTA_COROLLA_HYBRID_2023: [
    {
      label: 'Technology',
      title: 'Toyota Goes High-Tech: All About the Toyota Corolla Hybrid’s Infotainment Suite',
      videoIdPortrait: 'HsSkPFuLDUk',
      videoDuration: '0:57',
    },
    {
      label: 'Storage',
      title: 'Toyota Corolla Hybrid: All About the Storage Solutions',
      videoIdPortrait: 'Shes2R4Ls4Y',
      videoDuration: '0:56',
    },
    {
      label: 'Wildcard',
      title: 'The Differences Between the Toyota Corolla Hybrid and the Prius',
      videoIdPortrait: 'nawu8TxFqOM',
      videoDuration: '0:47',
    },
  ],
  TOYOTA_HIGHLANDER_HYBRID_2023: [
    {
      label: 'Interior',
      title: 'Toyota Highlander Hybrid: Passenger and Cargo Space',
      videoIdPortrait: 'jP7fMjWgwis',
      videoDuration: '0:51',
    },
    {
      label: 'Storage',
      title: 'Toyota Highlander Hybrid: Interior Tech Review',
      videoIdPortrait: '8A4QRcJ6b2s',
      videoDuration: '0:35',
    },
    {
      label: 'Fuel Economy',
      title: 'Toyota Highlander Hybrid: Fuel Economy',
      videoIdPortrait: 'TxT751Ppfuk',
      videoDuration: '0:44',
    },
  ],
  TOYOTA_RAV4_HYBRID_2023: [
    {
      label: 'Performance',
      title: '2023 Toyota RAV4 Hybrid: Safety Features',
      videoIdPortrait: 'nx6TEMdr0wk',
      videoDuration: '0:36',
    },
    {
      label: 'Storage',
      title: '2023 Toyota RAV4 Hybrid: Interior Space and Storage',
      videoIdPortrait: '7jTXabXnEPk',
      videoDuration: '0:58',
    },
    {
      label: 'Fuel Economy',
      title: '2023 Toyota RAV4 Hybrid: Fuel Economy',
      videoIdPortrait: '0Kud68EzB4I',
      videoDuration: '0:45',
    },
  ],
  TOYOTA_TUNDRA_2022: [
    {
      label: 'Performance',
      imageUrlPortrait: '/img/short-videos/2022-toyota-tundra/portrait/performance_desktop.jpg',
      videoIdPortrait: '740Kv14Y-IE',
      videoDuration: '2:22',
    },
    {
      label: 'Interior',
      imageUrlPortrait: '/img/short-videos/2022-toyota-tundra/portrait/interior_desktop.jpg',
      videoIdPortrait: 'qcQk0geAzgg',
      videoDuration: '1:32',
    },
    {
      label: 'Towing',
      imageUrlPortrait: '/img/short-videos/2022-toyota-tundra/portrait/storage_desktop.jpg',
      videoIdPortrait: '5CHrT3gX9Sw',
      videoDuration: '1:39',
    },
  ],
};
export const SHORT_VIDEOS_MAP = {
  acura: {
    mdx: { 2022: REUSED_MAPS.ACURA_MDX_2022, 2023: REUSED_MAPS.ACURA_MDX_2022, 2024: REUSED_MAPS.ACURA_MDX_2022 },
  },
  audi: {
    'rs-3': {
      2025: [
        {
          label: 'Performance',
          title: 'Is the Audi <span class="text-nowrap">RS 3</span> any fun to drive?',
          videoIdPortrait: 'mygaCEMMfJ8',
          videoDuration: '0:28',
        },
        {
          label: 'Interior',
          title: 'Is the Audi <span class="text-nowrap">RS 3’s</span> interior any good?',
          videoIdPortrait: '67_1mGScn3U',
          videoDuration: '0:37',
        },
        {
          label: 'Technology',
          title: 'I test the Audi <span class="text-nowrap">RS 3’s</span> technology and touchscreen',
          videoIdPortrait: 'T2vtonbyVqY',
          videoDuration: '0:45',
        },
        {
          label: 'Wildcard',
          title: 'How customizable are the Audi <span class="text-nowrap">RS 3’s</span> drive modes?',
          videoIdPortrait: 'Nz2pG3yHJJI',
          videoDuration: '0:34',
        },
      ],
    },
    q5: {
      2025: [
        {
          label: 'Comfort',
          title: 'How big is the Audi <span class="text-nowrap">Q5’s</span> back seat?',
          videoIdPortrait: 'NXw2Q9jXcW4',
          videoDuration: '0:24',
        },
        {
          label: 'Interior',
          title: 'The Audi <span class="text-nowrap">Q5’s</span> interior has one big misstep',
          videoIdPortrait: 'NbM49N0bLvA',
          videoDuration: '0:34',
        },
        {
          label: 'Technology',
          title: 'I test the Audi <span class="text-nowrap">Q5’s</span> technology and touchscreen',
          videoIdPortrait: 'qP5Ai9qDyXo',
          videoDuration: '0:30',
        },
        {
          label: 'Storage',
          title: 'Is the trunk big enough? Audi Q5 trunk cargo space review',
          videoIdPortrait: 'kplYSWimpIA',
          videoDuration: '0:33',
        },
      ],
    },
  },
  bmw: {
    ix: {
      2025: [
        {
          label: 'Comfort',
          title: 'The BMW iX Has an Awesome Feature That Every Luxury Car Should Have',
          videoIdPortrait: 'OhFdKBX0gLo',
          videoDuration: '0:30',
        },
        {
          label: 'Technology',
          title: 'BMW iX Interior Tech Overview',
          videoIdPortrait: '2er9ntKqjTQ',
          videoDuration: '0:43',
        },
        {
          label: 'Range and Efficiency',
          title: 'This Is How Far the BMW iX Will Travel on a Charge',
          videoIdPortrait: 'jxnU3q37kaA',
          videoDuration: '0:29',
        },
      ],
    },
    m2: {
      2025: [
        {
          label: 'Performance',
          title: 'The BMW M2 Gives You the Choice of Transmissions',
          videoIdPortrait: 'geszaVeGfKo',
          videoDuration: '0:29',
        },
        {
          label: 'Comfort',
          title: 'The BMW M2’s Interior Has One Major Problem',
          videoIdPortrait: 'Zcsd-c1ElWg',
          videoDuration: '0:24',
        },
        {
          label: 'Technology',
          title: 'How to Set Up the BMW M2’s Drive Modes',
          videoIdPortrait: 'g6V-EXIHxtE',
          videoDuration: '0:28',
        },
      ],
    },
  },
  buick: {
    enclave: {
      2025: [
        {
          label: 'Comfort',
          title: 'Buick Enclave Third-Row Overview',
          videoIdPortrait: 'g0QwzDcrvy8',
          videoDuration: '0:38',
        },
        {
          label: 'Interior',
          title: 'The Buick Enclave Is Basically a Luxury Minivan',
          videoIdPortrait: 'etHAbsgdUak',
          videoDuration: '0:36',
        },
        {
          label: 'Technology',
          title: 'Buick Enclave Interior Tech Overview',
          videoIdPortrait: 'gi9z1MaqCyE',
          videoDuration: '0:48',
        },
      ],
    },
  },
  cadillac: {
    escalade: {
      2023: REUSED_MAPS.CADILLAC_ESCALADE_2023,
      2024: REUSED_MAPS.CADILLAC_ESCALADE_2023,
    },
    optiq: {
      2026: [
        {
          label: 'Comfort',
          title: 'Can I get comfortable? Cadillac Optiq interior review',
          videoIdPortrait: 'Z-WVRptAOVE',
          videoDuration: '0:25',
        },
        {
          label: 'Interior',
          title: 'Is the Cadillac Optiq interior any good?',
          videoIdPortrait: 'inU6t2gWDJI',
          videoDuration: '0:34',
        },
        {
          label: 'Technology',
          title: "I test the Cadillac Optiq's technology and touchscreen",
          videoIdPortrait: 'Huvm_7oFb08',
          videoDuration: '0:29',
        },
      ],
    },
  },
  chevrolet: {
    camaro: {
      2023: REUSED_MAPS.CHEVROLET_CAMARO_2023,
      2024: REUSED_MAPS.CHEVROLET_CAMARO_2023,
    },
    colorado: {
      2024: [
        {
          label: 'Interior',
          title: 'Chevy Colorado Interior Overview',
          videoIdPortrait: 'i9jFuafdPL0',
          videoDuration: '0:32',
        },
        {
          label: 'Storage',
          title: 'Everything You Need to Know About the Chevy Colorado’s Interior Storage',
          videoIdPortrait: 'Szgaz8fb8FI',
          videoDuration: '0:40',
        },
        {
          label: 'Wildcard',
          title: 'Chevy Colorado Truck Bed Tips & Tricks',
          videoIdPortrait: '-lvLuYzN-LY',
          videoDuration: '0:33',
        },
      ],
      2025: [
        {
          label: 'Interior',
          title: 'Chevy Colorado Interior Overview',
          videoIdPortrait: 'Bco_uLRBgwo',
          videoDuration: '1:08',
        },
        {
          label: 'Storage',
          title: 'This Is What You Need to Know About the Chevy Colorado’s Cargo Capabilities',
          videoIdPortrait: 'Q4YN7sibt1g',
          videoDuration: '0:47',
        },
        {
          label: 'Wildcard',
          title: 'Everything You Get on the Chevy Colorado ZR2 Bison',
          videoIdPortrait: 'SmAkcvoHvao',
          videoDuration: '0:39',
        },
      ],
    },
    corvette: {
      2020: REUSED_MAPS.CHEVROLET_CORVETTE_2020,
      2021: REUSED_MAPS.CHEVROLET_CORVETTE_2020,
      2022: REUSED_MAPS.CHEVROLET_CORVETTE_2020,
      2023: REUSED_MAPS.CHEVROLET_CORVETTE_2020,
      2024: REUSED_MAPS.CHEVROLET_CORVETTE_2020,
    },
    equinox: {
      2025: [
        {
          label: 'Interior',
          title: 'Chevy Equinox Interior Overview: A Nice Place to Be',
          videoIdPortrait: '8Q7HPi1eZIk',
          videoDuration: '0:27',
        },
        {
          label: 'Technology',
          title: 'Chevy Equinox Technology Interface Overview',
          videoIdPortrait: 'vNmTOHeIKlQ',
          videoDuration: '0:39',
        },
        {
          label: 'Wildcard',
          title: 'Equinox Active Trim Level Overview',
          videoIdPortrait: '5sGI_4Ld47o',
          videoDuration: '0:19',
        },
      ],
    },
    'silverado-1500': {
      2023: REUSED_MAPS.CHEVROLET_SILVERADO_1500_2023,
      2024: REUSED_MAPS.CHEVROLET_SILVERADO_1500_2023,
    },
    tahoe: {
      2022: REUSED_MAPS.CHEVROLET_TAHOE_2022,
      2023: REUSED_MAPS.CHEVROLET_TAHOE_2022,
      2024: REUSED_MAPS.CHEVROLET_TAHOE_2022,
    },
    traverse: {
      2025: [
        {
          label: 'Technology',
          title: 'The Chevy Traverse Has Tons of Tech, But There’s a Catch',
          videoIdPortrait: 'SMrlb0n0JUU',
          videoDuration: '0:46',
        },
        {
          label: 'Storage',
          title: 'The Chevy Traverse Can Fit as Much Stuff as a Minivan',
          videoIdPortrait: 'Vr3BlgbgvOA',
          videoDuration: '0:34',
        },
        {
          label: 'Wildcard',
          title: 'The Chevy Traverse Can (Almost) Drive Itself',
          videoIdPortrait: 'B8x-WOb36xU',
          videoDuration: '0:40',
        },
      ],
    },
    trax: {
      2025: [
        {
          label: 'Comfort',
          title: 'Chevy Trax Rear Seat Test',
          videoIdPortrait: 'JOuROtlLW8E',
          videoDuration: '0:22',
        },
        {
          label: 'Technology',
          title: 'Chevy Trax Tech Overview',
          videoIdPortrait: '_SjHhZlAcik',
          videoDuration: '0:30',
        },
        {
          label: 'Storage',
          title: 'Chevy Trax Storage Overview',
          videoIdPortrait: 'RWxM4qcdjic',
          videoDuration: '0:29',
        },
      ],
    },
  },
  dodge: {
    challenger: {
      2023: [
        {
          label: 'Performance',
          title: '2023 Dodge Challenger Performance Overview',
          videoIdPortrait: 'rHXjFYrWZb0',
          videoDuration: '0:39',
        },
        {
          label: 'Exterior',
          title: '2023 Dodge Challenger Exterior Design Overview: Stone Cold Good Looks',
          videoIdPortrait: 'AdEgF2FnvUQ',
          videoDuration: '0:36',
        },
        {
          label: 'Interior',
          title: 'How Comfortable Is the 2023 Dodge Challenger?',
          videoIdPortrait: 'C2_01qUitEQ',
          videoDuration: '0:43',
        },
      ],
    },
    durango: {
      2024: [
        {
          label: 'Performance',
          title: 'Dodge Durango Engines: Which One is the Best?',
          videoIdPortrait: '4k2BAf70jFc',
          videoDuration: '0:27',
        },
        {
          label: 'Comfort',
          title: 'Is The Dodge Durango a Family Car?',
          videoIdPortrait: 'BgEXFtPl7UM',
          videoDuration: '0:26',
        },
        {
          label: 'Interior',
          title: 'Dodge Durango Interior Overview',
          videoIdPortrait: 'l9Mg9VJsT9o',
          videoDuration: '0:29',
        },
      ],
    },
  },
  ford: {
    bronco: {
      2022: [
        {
          label: 'Performance',
          imageUrlPortrait: '/img/short-videos/2022-ford-bronco/portrait/performance_desktop.jpg',
          videoIdPortrait: 'Pv3m539C3Ss',
          videoDuration: '1:00',
        },
        {
          label: 'Interior',
          imageUrlPortrait: '/img/short-videos/2022-ford-bronco/portrait/interior_desktop.jpg',
          videoIdPortrait: '_f3BJsdIWP8',
          videoDuration: '2:14',
        },
        {
          label: 'Storage',
          imageUrlPortrait: '/img/short-videos/2022-ford-bronco/portrait/storage_desktop.jpg',
          videoIdPortrait: 'd9a4eZIYI6g',
          videoDuration: '0:27',
        },
      ],
      2023: REUSED_MAPS.FORD_BRONCO_2023,
      2024: REUSED_MAPS.FORD_BRONCO_2023,
    },
    escape: {
      2023: REUSED_MAPS.FORD_ESCAPE_2023,
      2024: REUSED_MAPS.FORD_ESCAPE_2023,
    },
    expedition: {
      2025: [
        {
          label: 'Comfort',
          title: 'Do I fit? Ford Expedition 3rd-row space and comfort review',
          videoIdPortrait: '3JcsTf-YNWI',
          videoDuration: '0:27',
        },
        {
          label: 'Technology',
          title: "I test the Ford Expedition's technology and touchscreen",
          videoIdPortrait: 'hqN5xZMd8u4',
          videoDuration: '0:46',
        },
        {
          label: 'Storage',
          title: 'Is the trunk big enough? Ford Expedition trunk and cargo space review',
          videoIdPortrait: 'ZIWt48IxAjk',
          videoDuration: '0:37',
        },
        {
          label: 'Wildcard',
          title: 'How much can I fit? Ford Expedition cupholders and storage test',
          videoIdPortrait: 'zhVY7n2SDDA',
          videoDuration: '0:39',
        },
      ],
    },
    'f-150': {
      2023: REUSED_MAPS.FORD_F150_2023,
      2024: REUSED_MAPS.FORD_F150_2023.filter(({ label }) => label !== 'Interior'),
      2025: [
        {
          label: 'Technology',
          title: 'Ford <span class="text-nowrap">F-150:</span> How to Set Up Wireless Apple CarPlay',
          videoIdPortrait: 'pYk4wJsLceY',
          videoDuration: '0:53',
        },
        {
          label: 'Storage',
          title: 'Ford <span class="text-nowrap">F-150</span> Interior Storage Overview',
          videoIdPortrait: 'X0WKQ7vCiA8',
          videoDuration: '0:36',
        },
      ],
    },
    'f-150-lightning': {
      2023: REUSED_MAPS.FORD_F150_LIGHTNING_2023,
      2024: REUSED_MAPS.FORD_F150_LIGHTNING_2023,
    },
    maverick: {
      2023: REUSED_MAPS.FORD_MAVERICK_2023,
      2024: REUSED_MAPS.FORD_MAVERICK_2023,
      2025: [
        {
          label: 'Interior',
          title: 'Is the Ford Maverick’s interior any good?',
          videoIdPortrait: 'nvMLzIzLKbQ',
          videoDuration: '0:31',
        },
        {
          label: 'Technology',
          title: 'I test the Ford Maverick’s technology and touchscreen',
          videoIdPortrait: 'BwmKmqXT7Qg',
          videoDuration: '0:51',
        },
        {
          label: 'Storage',
          title: 'Is the bed big enough?',
          videoIdPortrait: 'mxlNyNoEJAE',
          videoDuration: '0:23',
        },
      ],
    },
    mustang: {
      2024: [
        {
          label: 'Performance',
          title: 'Ford Mustang Dark Horse Performance Overview',
          videoIdPortrait: 'hQDV7TjVwTM',
          videoDuration: '0:27',
        },
        {
          label: 'Interior',
          title: 'Ford Mustang Dark Horse Interior Overview: Screen Central',
          videoIdPortrait: '8IMTMVHufDE',
          videoDuration: '0:25',
        },
        {
          label: 'Wildcard',
          title: 'Explained: What’s a Mustang Dark Horse?',
          videoIdPortrait: '9rOYm5GVX0c',
          videoDuration: '0:30',
        },
      ],
    },
    'mustang-mach-e': {
      2021: REUSED_MAPS.FORD_MUSTANG_MACH_E_2021,
      2022: REUSED_MAPS.FORD_MUSTANG_MACH_E_2021,
      2023: REUSED_MAPS.FORD_MUSTANG_MACH_E_2021,
      2024: REUSED_MAPS.FORD_MUSTANG_MACH_E_2021,
    },
  },
  honda: {
    accord: {
      2023: REUSED_MAPS.HONDA_ACCORD_2023,
      2024: REUSED_MAPS.HONDA_ACCORD_2023,
    },
    civic: {
      2023: REUSED_MAPS.HONDA_CIVIC_2023,
      2024: REUSED_MAPS.HONDA_CIVIC_2023,
      2025: [
        {
          label: 'Interior',
          title: 'The Honda Civic Has a Seriously Nice Interior',
          videoIdPortrait: 'H40PAqRIEi8',
          videoDuration: '0:34',
        },
        {
          label: 'Technology',
          title: 'Honda Civic Sport Touring Tech Overview',
          videoIdPortrait: 'K6pWqMYyfHQ',
          videoDuration: '0:43',
        },
        {
          label: 'Storage',
          title: 'This Is What Sets the Honda Civic Hatchback Apart',
          videoIdPortrait: 'VS8R7Dppy1I',
          videoDuration: '0:41',
        },
      ],
    },
    'cr-v': {
      2022: [
        {
          label: 'Performance',
          imageUrlPortrait: '/img/short-videos/2022-honda-crv/portrait/performance_desktop.jpg',
          videoIdPortrait: 'u9ckEzAle8s',
          videoDuration: '1:02',
        },
        {
          label: 'Interior',
          imageUrlPortrait: '/img/short-videos/2022-honda-crv/portrait/interior_desktop.jpg',
          videoIdPortrait: 'GfECYXqYq5U',
          videoDuration: '1:59',
        },
        {
          label: 'Storage',
          imageUrlPortrait: '/img/short-videos/2022-honda-crv/portrait/storage_desktop.jpg',
          videoIdPortrait: 'aOyTqVSbFXs',
          videoDuration: '1:14',
        },
      ],
      2023: [
        {
          label: 'Performance',
          videoIdPortrait: 'Fs8yHx5819I',
          videoDuration: '0:50',
          imageUrlPortrait: '/img/short-videos/2023-honda-crv/portrait/performance.jpg',
        },
        {
          label: 'Interior',
          videoIdPortrait: '9uFkdpIl7a4',
          videoDuration: '1:35',
          imageUrlPortrait: '/img/short-videos/2023-honda-crv/portrait/interior.jpg',
        },
        {
          label: 'Storage',
          videoIdPortrait: '5kzJGqSxwcY',
          videoDuration: '1:13',
          imageUrlPortrait: '/img/short-videos/2023-honda-crv/portrait/storage.jpg',
        },
      ],
      2025: [
        {
          label: 'Interior',
          title: 'Honda <span class="text-nowrap">CR-V</span> Interior Storage Overview',
          videoIdPortrait: 'tmpmurX9sIY',
          videoDuration: '0:34',
        },
        {
          label: 'Storage',
          title: 'Honda <span class="text-nowrap">CR-V</span> Cargo Test',
          videoIdPortrait: '6filr4FNUGk',
          videoDuration: '0:28',
        },
        {
          label: 'Wildcard',
          title: 'The Honda <span class="text-nowrap">CR-V</span> Makes Using Car Seats a Breeze',
          videoIdPortrait: 't7gDrIaiFNI',
          videoDuration: '0:23',
        },
      ],
    },
    'hr-v': {
      2023: [
        {
          label: 'Performance',
          imageUrlPortrait: '/img/short-videos/2023-honda-hrv/portrait/performance_desktop.jpg',
          videoIdPortrait: '2UENS1-Qo5Q',
          videoDuration: '1:54',
        },
        {
          label: 'Interior',
          imageUrlPortrait: '/img/short-videos/2023-honda-hrv/portrait/interior_desktop.jpg',
          videoIdPortrait: 'tUXdRMqC63E',
          videoDuration: '1:25',
        },
        {
          label: 'Storage',
          imageUrlPortrait: '/img/short-videos/2023-honda-hrv/portrait/storage_desktop.jpg',
          videoIdPortrait: 'nKa5Fyf_FIU',
          videoDuration: '1:05',
        },
      ],
      2024: REUSED_MAPS.HONDA_HRV_2024,
      2025: REUSED_MAPS.HONDA_HRV_2024,
    },
    pilot: {
      2025: [
        {
          label: 'Technology',
          title: 'The Honda Pilot’s Tech Comes with a Catch',
          videoIdPortrait: '2-2tzjrlpm4',
          videoDuration: '0:41',
        },
        {
          label: 'Storage',
          title: 'The Honda Pilot Has Storage for Everything You’ll Need',
          videoIdPortrait: 'X2NP1zf8JZY',
          videoDuration: '0:43',
        },
        {
          label: 'Wildcard',
          title: 'Is the Honda Pilot TrailSport a Real Off-Roader?',
          videoIdPortrait: 'yESBQIlLFVM',
          videoDuration: '0:34',
        },
      ],
    },
  },
  hyundai: {
    'ioniq-6': {
      2025: [
        {
          label: 'Interior',
          title: 'Hyundai <span class="text-nowrap">Ioniq 6</span> Interior Overview',
          videoIdPortrait: 'Kd5il-yQUAA',
          videoDuration: '0:39',
        },
        {
          label: 'Technology',
          title: 'The Hyundai <span class="text-nowrap">Ioniq 6</span> Is High-Tech, But There’s a Catch',
          videoIdPortrait: '9gpfidfCXwU',
          videoDuration: '0:47',
        },
        {
          label: 'Storage',
          title: 'Hyundai <span class="text-nowrap">Ioniq 6</span>: Where’s the Trunk Space?',
          videoIdPortrait: 'vbWuEgtTxYQ',
          videoDuration: '0:34',
        },
      ],
    },
    palisade: {
      2026: [
        {
          label: 'Comfort',
          title: 'Can I get comfortable? Hyundai Palisade interior review',
          videoIdPortrait: 'FYF04bADFsA',
          videoDuration: '0:32',
        },
        {
          label: 'Interior',
          title: 'Is the Hyundai Palisade interior any good?',
          videoIdPortrait: 'EO0-IGr-wp8',
          videoDuration: '0:30',
        },
        {
          label: 'Storage',
          title: 'How’s the trunk? Hyundai Palisade cargo space review',
          videoIdPortrait: '4AYrRAEfl4I',
          videoDuration: '0:33',
        },
        {
          label: 'Wildcard',
          title: 'Do I fit? Hyundai Palisade 3rd-row space and comfort review',
          videoIdPortrait: 'UzXCAk3VxZs',
          videoDuration: '0:41',
        },
      ],
    },
    venue: {
      2024: [
        {
          label: 'Comfort',
          title: 'Hyundai Venue: Affordable, But at a Cost',
          videoIdPortrait: 'EfD2PetBwQA',
          videoDuration: '0:36',
        },
        {
          label: 'Interior',
          title: 'Here’s Why the Hyundai Venue’s Small Size Is a Big Advantage',
          videoIdPortrait: 'w_vzmKNhlIQ',
          videoDuration: '0:32',
        },
        {
          label: 'Value',
          title: 'Hyundai Venue: It’s Cheap, But It Ain’t Bad',
          videoIdPortrait: 'GUNDb66udUg',
          videoDuration: '0:21',
        },
      ],
    },
  },
  jeep: {
    'grand-cherokee': {
      2023: REUSED_MAPS.JEEP_GRAND_CHEROKEE_2023,
      2024: REUSED_MAPS.JEEP_GRAND_CHEROKEE_2023.filter(({ label }) => label !== 'Value'),
    },
    wrangler: {
      2023: [
        {
          label: 'Exterior',
          title: 'Jeep Wrangler Rubicon 4xe Exterior Walk-Around',
          videoIdPortrait: 'QV-mHVpa9tU',
          videoDuration: '0:45',
        },
        {
          label: 'Interior',
          title: 'Jeep Wrangler Rubicon 4xe Interior Overview',
          videoIdPortrait: 'XSIWJ6sD8po',
          videoDuration: '0:59',
        },
        {
          label: 'Fuel Economy',
          title: 'Jeep Wrangler Rubicon 4xe: How Is the Plug-in Hybrid’s Fuel Economy?',
          videoIdPortrait: 'VmqytKqzqDk',
          videoDuration: '0:38',
        },
      ],
      2025: [
        {
          label: 'Comfort',
          title: 'This Is Why You Might Want to Think Twice Before Buying a Jeep Wrangler',
          videoIdPortrait: '7Sg5xoAneuU',
          videoDuration: '0:42',
        },
        {
          label: 'Technology',
          title: 'Jeep Wrangler Off-Road Tech Overview',
          videoIdPortrait: 'UmnPVwRP9vE',
          videoDuration: '1:08',
        },
        {
          label: 'Wildcard',
          title: 'This Is One of the Jeep Wrangler’s Most Useful Features',
          videoIdPortrait: 'BnxyYn8Ryqg',
          videoDuration: '0:25',
        },
      ],
    },
  },
  kia: {
    carnival: {
      2025: [
        {
          label: 'Technology',
          title: 'Kia Carnival Interior Tech Overview',
          videoIdPortrait: 'awD_jP63yEQ',
          videoDuration: '0:40',
        },
        {
          label: 'Storage',
          title: 'Kia Carnival Cargo Capacity Overview',
          videoIdPortrait: 'sLe6yEosbQo',
          videoDuration: '0:26',
        },
        {
          label: 'Wildcard',
          title: 'Kia Carnival Cupholder Demo',
          videoIdPortrait: 'rsqz_pHqtGo',
          videoDuration: '0:53',
        },
      ],
    },
    'carnival-hybrid': {
      2025: [
        {
          label: 'Comfort',
          title: 'The Kia Carnival’s back seat is ultra-luxurious',
          videoIdPortrait: 'IVStf_dffe8',
          videoDuration: '0:45',
        },
        {
          label: 'Interior',
          title: 'Is the Kia Carnival’s interior any good?',
          videoIdPortrait: 'HWuxkMb8JIs',
          videoDuration: '0:32',
        },
        {
          label: 'Technology',
          title: 'The Kia Carnival’s interior has one big misstep',
          videoIdPortrait: '_jq0Yrblkso',
          videoDuration: '0:43',
        },
        {
          label: 'Storage',
          title: 'How’s the trunk? Kia Carnival trunk and cargo space review',
          videoIdPortrait: '6_nnKoJEhQg',
          videoDuration: '0:37',
        },
      ],
    },
    sorento: {
      2021: REUSED_MAPS.KIA_SORENTO_2021,
      2022: REUSED_MAPS.KIA_SORENTO_2021,
      2023: REUSED_MAPS.KIA_SORENTO_2021,
      2024: REUSED_MAPS.KIA_SORENTO_2021,
      2025: [
        {
          label: 'Interior',
          title: 'Kia Sorento Third-Row Seat Overview',
          videoIdPortrait: 'P59Jlq6AASs',
          videoDuration: '0:40',
        },
        {
          label: 'Storage',
          title: 'Kia Sorento Cargo Capacity Overview',
          videoIdPortrait: '4YsIKjyzSWQ',
          videoDuration: '0:39',
        },
        {
          label: 'Fuel Economy',
          title: 'Everything You Need to Know About the Kia Sorento’s Powertrain Options',
          videoIdPortrait: 'wODZwVswrRk',
          videoDuration: '0:37',
        },
      ],
    },
    sportage: {
      2023: REUSED_MAPS.KIA_SPORTAGE_2023,
      2024: REUSED_MAPS.KIA_SPORTAGE_2023,
      2025: [
        {
          label: 'Interior',
          title: 'Is the Kia Sportage’s interior any good?',
          videoIdPortrait: 'AK1j51wD0eQ',
          videoDuration: '0:33',
        },
        {
          label: 'Technology',
          title: 'I test the Kia Sportage’s technology and touchscreen',
          videoIdPortrait: 'wmajY4d_THI',
          videoDuration: '0:56',
        },
        {
          label: 'Storage',
          title: 'Is the trunk big enough? Kia Sportage trunk and cargo space review',
          videoIdPortrait: 'pseJ7k5xDTA',
          videoDuration: '0:22',
        },
      ],
    },
    stinger: {
      2023: [
        {
          label: 'Performance',
          title: '2023 Kia Stinger Performance Overview',
          videoIdPortrait: 'YQxoQyXjtek',
          videoDuration: '0:44',
        },
        {
          label: 'Exterior',
          title: '2023 Kia Stinger Design Overview: Stylish',
          videoIdPortrait: 'I6QNObGxP2g',
          videoDuration: '0:48',
        },
        {
          label: 'Storage',
          title: '2023 Kia Stinger Hatchback & Cargo Space',
          videoIdPortrait: 'S3cmstvdDoE',
          videoDuration: '0:39',
        },
      ],
    },
    telluride: {
      2023: REUSED_MAPS.KIA_TELLURIDE_2023,
      2024: REUSED_MAPS.KIA_TELLURIDE_2023,
    },
  },
  'land-rover': {
    'range-rover': {
      2024: [
        {
          label: 'Comfort',
          title: 'Here’s How Spacious a Range Rover Is',
          videoIdPortrait: 'YRRHSCGQzik',
          videoDuration: '0:26',
        },
        {
          label: 'Technology',
          title: 'Land Rover Range Rover Infotainment Overview',
          videoIdPortrait: 'eEVGf6f3_bg',
          videoDuration: '0:23',
        },
        {
          label: 'Value',
          title: 'Here’s Why the Land Rover Range Rover is Worth the Money',
          videoIdPortrait: 'CHnliJcTJCw',
          videoDuration: '0:58',
        },
      ],
    },
  },
  lexus: {
    nx: {
      2025: [
        {
          label: 'Exterior',
          title: 'The Lexus NX Is a Stylish Small Luxury SUV',
          videoIdPortrait: '8Tf9riLligA',
          videoDuration: '0:31',
        },
        {
          label: 'Interior',
          title: 'Lexus NX Interior Overview',
          videoIdPortrait: 'kLpGve7NXPU',
          videoDuration: '0:45',
        },
        {
          label: 'Technology',
          title: 'The Lexus NX Blends High-Tech with Luxury',
          videoIdPortrait: 'kLpGve7NXPU',
          videoDuration: '0:45',
        },
      ],
    },
    rx: {
      2025: [
        {
          label: 'Comfort',
          title: 'The Lexus RX F Sport Has Front Seats That Are Just Too Narrow',
          videoIdPortrait: 'I8Fn2oG0YQk',
          videoDuration: '0:40',
        },
        {
          label: 'Technology',
          title: 'The Lexus RX Has One Major Tech Issue',
          videoIdPortrait: 'SUBTNHxOZKA',
          videoDuration: '0:29',
        },
        {
          label: 'Storage',
          title: 'Lexus RX Cargo & Utility Overview',
          videoIdPortrait: '2Uq07Ouubgw',
          videoDuration: '0:21',
        },
      ],
    },
  },
  lucid: {
    gravity: {
      2026: [
        {
          label: 'Interior',
          title: 'Is the Lucid Gravity’s interior any good?',
          videoIdPortrait: 'IVkuNki0Ufo',
          videoDuration: '0:26',
        },
        {
          label: 'Technology',
          title: 'I test the Lucid Gravity’s interior tech and touchscreen',
          videoIdPortrait: '-LN5VKaTV68',
          videoDuration: '1:00',
        },
        {
          label: 'Storage',
          title: 'Is the trunk big enough? Lucid Gravity trunk and cargo space review',
          videoIdPortrait: '3MxzXgA-dcE',
          videoDuration: '0:31',
        },
      ],
    },
  },
  mazda: {
    'cx-5': {
      2023: REUSED_MAPS.MAZDA_CX5_2023,
      2024: REUSED_MAPS.MAZDA_CX5_2023,
    },
    'cx-50': {
      2023: REUSED_MAPS.MAZDA_CX50_2023,
      2024: REUSED_MAPS.MAZDA_CX50_2023,
    },
    'mx-5-miata': {
      2024: [
        {
          label: 'Interior',
          title: 'Mazda <span class="text-nowrap">MX-5:</span> Miata: How’s the Interior Space?',
          videoIdPortrait: 'meA-gvQl9Tk',
          videoDuration: '0:33',
        },
        {
          label: 'Technology',
          title: 'Mazda <span class="text-nowrap">MX-5:</span> Miata Tech Experience Overview',
          videoIdPortrait: 'Cdv0U15ikhE',
          videoDuration: '0:27',
        },
        {
          label: 'Wildcard',
          title:
            'Mazda <span class="text-nowrap">MX-5:</span> Miata: Hardtop vs. Soft Top | Which One Is Right For You?',
          videoIdPortrait: 'ey5Yf8I2Zv8',
          videoDuration: '0:43',
        },
      ],
    },
  },
  'mercedes-benz': {
    'g-class': {
      2025: [
        {
          label: 'Performance',
          title: 'Mercedes-Benz <span class="text-nowrap">G-Class</span> Off-Road Overview',
          videoIdPortrait: '9MBb94VxYxA',
          videoDuration: '0:53',
        },
        {
          label: 'Interior',
          title: 'This Is What You Need to Know About the <span class="text-nowrap">G-Wagen’s</span> Interior',
          videoIdPortrait: 'PgEiSSwzwjg',
          videoDuration: '0:47',
        },
        {
          label: 'Wildcard',
          title: 'This Is How Mercedes Makes the AMG G 63 Feel Special',
          videoIdPortrait: '3_8IdBBL028',
          videoDuration: '0:52',
        },
      ],
    },
    'gls-class': { 2022: REUSED_MAPS.MERCEDES_BENZ_GLS_CLASS_2022, 2023: REUSED_MAPS.MERCEDES_BENZ_GLS_CLASS_2022 },
  },
  polestar: {
    3: {
      2025: [
        {
          label: 'Comfort',
          title: 'Polestar 3: How Big Is It? ',
          videoIdPortrait: 'pkKQm3DGhxA',
          videoDuration: '0:30',
        },
        {
          label: 'Interior',
          title: 'Polestar 3: How’s the Interior?',
          videoIdPortrait: 'iw6aRMlX1pE',
          videoDuration: '0:45',
        },
        {
          label: 'Technology',
          title: 'Polestar 3 Tech Overview',
          videoIdPortrait: 'RJBhXLyygSM',
          videoDuration: '0:50',
        },
        {
          label: 'Storage',
          title: 'Polestar 3: How Much Can It Hold?',
          videoIdPortrait: 'Kf8T0jcOBUY',
          videoDuration: '0:37',
        },
        {
          label: 'Wildcard',
          title: 'Polestar 3: What Is It?',
          videoIdPortrait: '2U-VkFpUvtg',
          videoDuration: '0:53',
        },
      ],
    },
  },
  porsche: {
    911: {
      2023: REUSED_MAPS.PORSCHE_911_2023,
      2024: REUSED_MAPS.PORSCHE_911_2023,
    },
  },
  rivian: {
    r1s: {
      2025: [
        {
          label: 'Comfort',
          title: 'Do I fit? Rivian R1S 3rd row space and comfort review',
          videoIdPortrait: 'U-WVrC2RZUs',
          videoDuration: '0:26',
        },
        {
          label: 'Interior',
          title: 'Is the Rivian R1S’ interior any good?',
          videoIdPortrait: 'kCgglAVz7_w',
          videoDuration: '0:27',
        },
        {
          label: 'Technology',
          title: 'I test the Rivian R1S’ technology and touchscreen',
          videoIdPortrait: '9K78K_8MVUI',
          videoDuration: '0:36',
        },
        {
          label: 'Storage',
          title: 'Is the trunk big enough? Rivian R1S trunk and cargo space review',
          videoIdPortrait: 'hSKKxX7YSKo',
          videoDuration: '0:40',
        },
      ],
    },
    r1t: {
      2022: REUSED_MAPS.RIVIAN_R1T_2022,
      2023: REUSED_MAPS.RIVIAN_R1T_2022,
      2024: REUSED_MAPS.RIVIAN_R1T_2022,
    },
  },
  subaru: {
    brz: {
      2025: [
        {
          label: 'Comfort',
          title: 'The Subaru BRZ’s rear seat is impressively tiny',
          videoIdPortrait: 'pFn3Fp57IR4',
          videoDuration: '0:34',
        },
        {
          label: 'Interior',
          title: 'Is the Subaru BRZ’s interior any good?',
          videoIdPortrait: 'oZDH9LUgnXo',
          videoDuration: '0:27',
        },
        {
          label: 'Technology',
          title: 'I test the Subaru BRZ’s technology and touchscreen',
          videoIdPortrait: 'gaFx0LZEzl0',
          videoDuration: '0:42',
        },
      ],
    },
    crosstrek: {
      2025: [
        {
          label: 'Interior',
          title: 'Subaru Crosstrek Interior Overview',
          videoIdPortrait: 'jm9qI9P6sMY',
          videoDuration: '0:28',
        },
        {
          label: 'Technology',
          title: 'The Subaru Crosstrek Has Frustrating Interior Tech',
          videoIdPortrait: 'd7cRYOqt-0M',
          videoDuration: '0:36',
        },
        {
          label: 'Storage',
          title: 'How Much Stuff Can Fit in a Subaru Crosstrek?',
          videoIdPortrait: 'Yd7g_tRS-qE',
          videoDuration: '0:47',
        },
      ],
    },
    forester: {
      2025: [
        {
          label: 'Performance',
          title: 'The Subaru Forester Can Off-Road Better Than You Think',
          videoIdPortrait: 'YX_xhoKx7-E',
          videoDuration: '0:52',
        },
        {
          label: 'Interior',
          title: 'Subaru Forester Interior Overview',
          videoIdPortrait: 'DeY14fecbxk',
          videoDuration: '0:39',
        },
        {
          label: 'Technology',
          title: 'Subaru Forester Technology Overview',
          videoIdPortrait: 'rUS5TYszmwA',
          videoDuration: '0:40',
        },
        {
          label: 'Interior',
          title: 'Is the Subaru Forester’s interior any good?',
          videoIdPortrait: 'WFd53nhWH-E',
          videoDuration: '0:55',
        },
        {
          label: 'Technology',
          title: "I test the Subaru Forester’'s technology and touchscreen",
          videoIdPortrait: 'qkMzeu0tVC8',
          videoDuration: '0:54',
        },
        {
          label: 'Storage',
          title: 'How’s the trunk? Subaru Forester Hybrid cargo space review',
          videoIdPortrait: '116euDmwlFQ',
          videoDuration: '0:41',
        },
      ],
    },
    outback: {
      2025: [
        {
          label: 'Technology',
          title: 'The Subaru Outback Is a Tech Disappointment',
          videoIdPortrait: 'zymgEI2fsmE',
          videoDuration: '0:39',
        },
        {
          label: 'Storage',
          title: 'Subaru Outback Storage Overview',
          videoIdPortrait: 'xN5Ipg0KzNg',
          videoDuration: '0:41',
        },
        {
          label: 'Wildcard',
          title: 'The Subaru Outback Is a Real Off-Roader',
          videoIdPortrait: 'aKsmnaBM21k',
          videoDuration: '0:30',
        },
      ],
    },
  },
  tesla: {
    'model-3': {
      2023: [
        {
          label: 'Technology',
          title: 'Tesla Model 3 Infotainment Overview',
          videoIdPortrait: 'aNQ_IAUuO2o',
          videoDuration: '0:55',
        },
        {
          label: 'Fuel Economy',
          title: 'Planning a Road Trip in the Tesla Model 3',
          videoIdPortrait: '8tHXVKb0XUE',
          videoDuration: '0:38',
        },
        {
          label: 'Wildcard',
          title: 'Tesla Model 3: Everything You Need to Know About the Convenient Buying Process',
          videoIdPortrait: 'eLYrGnzSX2o',
          videoDuration: '0:34',
        },
      ],
      2025: [
        {
          label: 'Performance',
          title: 'The Model 3 Performance Is the Most Athletic Tesla',
          videoIdPortrait: 'LPAt58Km9do',
          videoDuration: '0:50',
        },
        {
          label: 'Interior',
          title: 'Tesla Model 3 Interior Overview',
          videoIdPortrait: 'MdJoQGvvmYU',
          videoDuration: '0:28',
        },
        {
          label: 'Wildcard',
          title: 'These Are the Extra Features in the Tesla Model 3 Performance',
          videoIdPortrait: '2PaZ_gMEaws',
          videoDuration: '0:41',
        },
      ],
    },
    'model-y': {
      2023: REUSED_MAPS.TESLA_MODEL_Y_2023,
      2024: REUSED_MAPS.TESLA_MODEL_Y_2023,
    },
  },
  toyota: {
    '4runner': {
      2024: [
        {
          label: 'Performance',
          title: 'Toyota 4Runner: How’s the Engine?',
          videoIdPortrait: '_YOu0gDel94',
          videoDuration: '0:18',
        },
        {
          label: 'Interior',
          title: 'Toyota 4Runner Interior Overview',
          videoIdPortrait: 'uQ5p7NKnGDg',
          videoDuration: '0:50',
        },
        {
          label: 'Wildcard',
          title: 'Toyota 4Runner Off-Road Overview',
          videoIdPortrait: 'DwNOApf7xKw',
          videoDuration: '0:26',
        },
      ],
      2025: [
        {
          label: 'Comfort',
          title: 'The Toyota 4Runner’s back seat is smaller than you might think',
          videoIdPortrait: 'g7ixYcXWS1A',
          videoDuration: '0:22',
        },
        {
          label: 'Interior',
          title: 'Is the Toyota 4Runner’s interior any good?',
          videoIdPortrait: '59tSy_rQdbw',
          videoDuration: '0:29',
        },
        {
          label: 'Storage',
          title: 'Is the trunk big enough? Toyota 4Runner trunk and cargo space review',
          videoIdPortrait: 'D-qL5NHcHkY',
          videoDuration: '0:36',
        },
      ],
    },
    bz: {
      2026: [
        {
          label: 'Interior',
          title: 'Is the Toyota bZ interior any good?',
          videoIdPortrait: '3HdKzo8aaPw',
          videoDuration: '0:26',
        },
        {
          label: 'Technology',
          title: "I test the Toyota bZ's technology and touchscreen",
          videoIdPortrait: 'kE14JetefxA',
          videoDuration: '0:35',
        },
        {
          label: 'Storage',
          title: 'Is the trunk big enough? Toyota bZ trunk and cargo space review',
          videoIdPortrait: 'vGxhYzntx6k',
          videoDuration: '0:27',
        },
      ],
    },
    'corolla-cross': {
      2022: REUSED_MAPS.TOYOTA_COROLLA_CROSS_2022,
      2023: REUSED_MAPS.TOYOTA_COROLLA_CROSS_2022.filter(({ label }) => label !== 'Interior'),
      2024: REUSED_MAPS.TOYOTA_COROLLA_CROSS_2022.filter(({ label }) => label !== 'Interior'),
    },
    'camry-hybrid': {
      2023: REUSED_MAPS.TOYOTA_CAMRY_HYBRID_2023,
      2024: REUSED_MAPS.TOYOTA_CAMRY_HYBRID_2023,
    },
    'corolla-hybrid': {
      2023: REUSED_MAPS.TOYOTA_COROLLA_HYBRID_2023,
      2024: REUSED_MAPS.TOYOTA_COROLLA_HYBRID_2023,
    },
    crown: {
      2025: [
        {
          label: 'Comfort',
          title: 'How’s the Toyota Crown’s Utility?',
          videoIdPortrait: '2QdRwm540Yg',
          videoDuration: '0:58',
        },
        {
          label: 'Interior',
          title: 'Toyota Crown Interior Overview: Is It Luxurious Enough?',
          videoIdPortrait: '3Q6Pot6unJs',
          videoDuration: '0:30',
        },
        {
          label: 'Wildcard',
          title: 'Is the Toyota Crown a Sedan, an SUV or a Crossover?',
          videoIdPortrait: 'mwWTmsNKJpM',
          videoDuration: '0:38',
        },
      ],
    },
    'grand-highlander': {
      2024: [
        {
          label: 'Interior',
          title: 'Toyota Grand Highlander Interior Overview',
          videoIdPortrait: 'AeDhZLKaZlg',
          videoDuration: '0:24',
        },
        {
          label: 'Storage',
          title: 'Toyota Grand Highlander: How Spacious is it?',
          videoIdPortrait: 'z7iN8HLr3fI',
          videoDuration: '0:34',
        },
        {
          label: 'Fuel Economy',
          title: 'Toyota Grand Highlander: What’s Hybrid Max?',
          videoIdPortrait: 'VTvvUmtaSNM',
          videoDuration: '0:34',
        },
      ],
    },
    'grand-highlander-hybrid': {
      2025: [
        {
          label: 'Comfort',
          title: 'Can I get comfortable? Toyota Grand Highlander interior review',
          videoIdPortrait: 'qlRLQyKgGG8',
          videoDuration: '0:37',
        },
        {
          label: 'Interior',
          title: 'Toyota Grand Highlander interior storage review',
          videoIdPortrait: '_hDiyjrYzbM',
          videoDuration: '0:35',
        },
        {
          label: 'Technology',
          title: 'I test the Toyota Grand Highlander’s technology',
          videoIdPortrait: '2PiiCtzKJzQ',
          videoDuration: '1:03',
        },
      ],
    },
    highlander: {
      2025: [
        {
          label: 'Comfort',
          title: 'Does the Toyota Highlander Have a Usable Third Row?',
          videoIdPortrait: '45KFJEeG6d0',
          videoDuration: '0:44',
        },
        {
          label: 'Technology',
          title: 'Toyota Highlander Tech Overview',
          videoIdPortrait: 'DSGSsF7EJ4k',
          videoDuration: '0:39',
        },
        {
          label: 'Storage',
          title: 'How’s the Toyota Highlander’s Cargo Space?',
          videoIdPortrait: 'BuOLvS6lf7s',
          videoDuration: '0:25',
        },
      ],
    },
    'highlander-hybrid': {
      2023: REUSED_MAPS.TOYOTA_HIGHLANDER_HYBRID_2023,
      2024: REUSED_MAPS.TOYOTA_HIGHLANDER_HYBRID_2023,
    },
    rav4: {
      2023: [
        {
          label: 'Interior',
          title: 'The Toyota RAV4’s Spacious Interior',
          videoIdPortrait: '7jTXabXnEPk',
          videoDuration: '0:58',
        },
        {
          label: 'Fuel Economy',
          title: 'Toyota RAV4 Hybrid Fuel Economy',
          videoIdPortrait: '0Kud68EzB4I',
          videoDuration: '0:45',
        },
        {
          label: 'Safety',
          title: 'Toyota RAV4 Safety Features',
          videoIdPortrait: 'nx6TEMdr0wk',
          videoDuration: '0:36',
        },
      ],
    },
    'rav4-hybrid': {
      2023: REUSED_MAPS.TOYOTA_RAV4_HYBRID_2023,
      2024: REUSED_MAPS.TOYOTA_RAV4_HYBRID_2023,
    },
    sienna: {
      2024: [
        {
          label: 'Comfort',
          title: 'Here’s Why the Toyota Sienna Is Better Than an SUV',
          videoIdPortrait: 'UiP0Ax9J9ls',
          videoDuration: '0:36',
        },
        {
          label: 'Storage',
          title: 'Toyota Sienna Storage Space Overview',
          videoIdPortrait: 'bFAjorFaIa8',
          videoDuration: '0:33',
        },
        {
          label: 'Wildcard',
          title: 'Toyota Sienna: Does It Baby? | Car Seat & Safety Overview',
          videoIdPortrait: 'AAjYTRYIE4s',
          videoDuration: '0:37',
        },
      ],
      2025: [
        {
          label: 'Comfort',
          title: 'The Toyota Sienna Can Keep Your Kids Cool',
          videoIdPortrait: 'WAmwAjDg47U',
          videoDuration: '0:30',
        },
        {
          label: 'Interior',
          title: 'The Toyota Sienna’s Rear Seats Have Tricks Up Their Sleeve',
          videoIdPortrait: 'eXsNUYNqqYg',
          videoDuration: '0:51',
        },
        {
          label: 'Storage',
          title: 'Toyota Sienna Cupholder Test',
          videoIdPortrait: 'vpPibtbqtso',
          videoDuration: '1:08',
        },
      ],
    },
    tacoma: {
      2025: [
        {
          label: 'Performance',
          title: 'The Toyota Tacoma Is Seriously Capable Off-Road',
          videoIdPortrait: 'wE4XYwcODu4',
          videoDuration: '0:30',
        },
        {
          label: 'Interior',
          title: 'Toyota Tacoma Interior Overview',
          videoIdPortrait: 'dG7-hKPBIk8',
          videoDuration: '0:42',
        },
        {
          label: 'Wildcard',
          title: 'Toyota Tacoma Towing & Hauling Overview',
          videoIdPortrait: 'bEv9QgW45dE',
          videoDuration: '0:34',
        },
      ],
    },
    tundra: {
      2022: REUSED_MAPS.TOYOTA_TUNDRA_2022,
      2023: REUSED_MAPS.TOYOTA_TUNDRA_2022,
      2024: REUSED_MAPS.TOYOTA_TUNDRA_2022,
    },
  },
  volkswagen: {
    atlas: {
      2025: [
        {
          label: 'Technology',
          title: 'Volkswagen Atlas Interior Tech Overview',
          videoIdPortrait: 'bDq5C_xPmw4',
          videoDuration: '0:34',
        },
        {
          label: 'Storage',
          title: 'How Much Cargo Can Fit in a Volkswagen Atlas?',
          videoIdPortrait: 'hnAkn-dnFSs',
          videoDuration: '0:31',
        },
      ],
    },
    tiguan: {
      2025: [
        {
          label: 'Interior',
          title: 'Is the Volkswagen Tiguan’s interior any good?',
          videoIdPortrait: 'l8e6KvItsvY',
          videoDuration: '0:31',
        },
        {
          label: 'Technology',
          title: 'I test the Volkswagen Tiguan’s technology and touchscreen',
          videoIdPortrait: 'TqE10X3LIfU',
          videoDuration: '0:37',
        },
        {
          label: 'Storage',
          title: 'Is the trunk big enough? Volkswagen Tiguan trunk and cargo space review',
          videoIdPortrait: 'R0QfoedKvYk',
          videoDuration: '0:20',
        },
      ],
    },
  },
  volvo: {
    xc60: {
      2025: [
        {
          label: 'Interior',
          title: 'Volvo XC60 Backseat Overview',
          videoIdPortrait: 'c8wJY_n0T-M',
          videoDuration: '0:34',
        },
        {
          label: 'Technology',
          title: 'The Volvo XC60 Is Missing One Major Tech Feature',
          videoIdPortrait: 'bOS6Vk4JlEA',
          videoDuration: '0:28',
        },
        {
          label: 'Storage',
          title: 'The Volvo XC60 Makes Loading Cargo Easier',
          videoIdPortrait: '-AZWdP6R9BI',
          videoDuration: '0:23',
        },
      ],
    },
    xc90: {
      2026: [
        {
          label: 'Comfort',
          title: 'Do I fit? Volvo XC90 3rd-row space and comfort review',
          videoIdPortrait: 'Ct7yOw6i8gA',
          videoDuration: '0:34',
        },
        {
          label: 'Interior',
          title: 'Is the Volvo XC90 interior any good?',
          videoIdPortrait: 'kEfuGssAl8E',
          videoDuration: '0:33',
        },
        {
          label: 'Technology',
          title: "I test the Volvo XC90's technology and touchscreen",
          videoIdPortrait: 'OaWmXoRmaR8',
          videoDuration: '0:58',
        },
      ],
    },
  },
};
